import React from "react";
import { useFormContext } from "react-hook-form";
import { ContentSection, FormDropdown, FormMultiselectDropdown, mapToDropdownOption } from "sprint-common-web";

import { useCreateFileRecordFormOptions } from "../hooks/useCreateFileRecordFormOptions";

export const CreateVideoFileRecordLanguagesForm: React.FC = () => {
    const { dubbings, embeddedSubtitles, areOptionsLoading } = useCreateFileRecordFormOptions();
    const { errors, control } = useFormContext();

    return (
        <ContentSection
            header="Languages"
            isLoading={areOptionsLoading}
            style={{ minHeight: "39vh", marginBottom: "2vh" }}
        >
            <FormMultiselectDropdown
                options={dubbings.map((dub) => mapToDropdownOption(dub))}
                label="Soundtracks"
                name={"videoSoundtracks"}
                control={control}
                errors={errors}
            />
            <FormDropdown
                options={embeddedSubtitles.map((sub) => mapToDropdownOption(sub))}
                label="Subtitle"
                name={"videoSubtitle"}
                control={control}
                errors={errors}
            />
        </ContentSection>
    );
};
